/**
 * Funder-name matching that agrees with how the backend groups rows onto a
 * funder card.
 *
 * Mirrors `_funder_key` in `backend/apps/ai_services/analysis_assembly.py`:
 * lowercase, drop `.`/`,`, collapse whitespace, and strip trailing corporate
 * suffixes. Stage 1 transcribes each statement on its own, so the same funder
 * shows up as "UFCE" in one month and "Ufce" in the next, or "Apple Advance"
 * on the funding deposit and "Apple Advance LLC" on the pulls. The card is
 * built from all of those rows; a filter that compares raw strings shows one.
 */
const CORPORATE_SUFFIXES = new Set([
  "llc",
  "inc",
  "incorporated",
  "corp",
  "corporation",
  "co",
  "company",
  "ltd",
  "lp",
  "llp",
]);

export function normalizeFunderName(name: string | null | undefined): string {
  const words = (name ?? "").replace(/[.,]/g, "").trim().toLowerCase().split(/\s+/).filter(Boolean);
  while (words.length > 0 && CORPORATE_SUFFIXES.has(words[words.length - 1])) {
    words.pop();
  }
  return words.join(" ") || "unknown funder";
}

export function isSameFunder(a: string | null | undefined, b: string | null | undefined): boolean {
  return normalizeFunderName(a) === normalizeFunderName(b);
}
